import { Pipe, PipeTransform } from '@angular/core';
import { sanitizeToDateTime } from 'src/app/shared/helpers/formatDates';

@Pipe({
    name: 'sanitizeToDateTime',
    standalone: false
})
export class SanitizeToDateTimePipe implements PipeTransform {
  transform(value: any): string {
    return sanitizeToDateTime(value);
  }
}
